import VARIANTS from "../data/image-variants.json";

/* Intrinsic pixel sizes for the images served from /static.
 *
 * Every <img> on the site should carry width and height so the browser can
 * reserve the right box before the file arrives, which is what keeps the
 * showcase and the blog from shifting under the reader mid-load. The files
 * are plain static assets rather than gatsby-image nodes, so nothing knows
 * their dimensions at build time unless we say so here.
 *
 * Keys are public paths, exactly as written in frontmatter and in the
 * project list. SVG entries are the viewBox, which is what a browser treats
 * as the intrinsic size. Add a row whenever a new image lands in /static; a
 * missing row degrades to no attributes rather than a wrong box.
 */
const SIZES = {
  "/aigroupcall.png": [1254, 1254],
  "/overbrilliant.png": [1536, 1024],
  "/planintel.png": [1134, 1134],
  "/screens/ue/cover.webp": [1672, 941],
  "/screens/covers/agentdomains.webp": [1672, 941],
  "/screens/covers/circlechat.webp": [1672, 941],
  "/screens/covers/draw-a-tune.webp": [1672, 941],
  "/screens/covers/overbrilliant.webp": [1672, 941],
  "/screens/covers/planintel.webp": [1672, 941],
  "/screens/covers/fit-your-wit.webp": [1672, 941],
  "/projects/viral-ugc-stills-v1.webp": [1536, 1024],
  "/projects/reel-creators-v1.webp": [1536, 1024],
  "/blog-agent-cost-chart.svg": [1200, 560],
  "/blog-ai-tinkerers.jpg": [1600, 900],
  "/blog-aigroupcall-launch.jpg": [1600, 957],
  "/blog-ait-chat.jpg": [1200, 1500],
  "/blog-ait-crowd.jpg": [1200, 1500],
  "/blog-ait-demo.jpg": [1600, 1066],
  "/blog-ait-room.jpg": [1600, 1066],
  "/blog-betaware-launch.jpg": [1600, 800],
  "/blog-circlechat-relaunch.jpg": [1600, 957],
  "/blog-freellmapi-ph.jpg": [1264, 720],
  "/blog-ob1-launch.jpg": [1600, 1067],
  "/blog-ornith-chart.svg": [1200, 660],
  "/blog-scallop-chart.svg": [1200, 680],
  "/blog/dublin-ai-week/demos-anon-cover.jpg": [1265, 1265],
  "/blog/dublin-ai-week/uxdx-design-talk.jpg": [1280, 1173],
  "/blog/dublin-ai-week/uxdx-community-talk.jpg": [1186, 1173],
  "/blog/dublin-ai-week/demos-anon-welcome.jpg": [1265, 1265],
  "/blog/dublin-ai-week/dublin-ai-week-community.jpg": [1173, 1173],
  "/blog/dublin-ai-week/uxdx-recap-poster.jpg": [720, 960],
  "/blog/magic-tap/cover.jpg": [1600, 900],
  "/blog/magic-tap/video-poster.jpg": [1600, 900],
  "/blog/magic-tap/pipeline.webp": [2400, 1350],
  "/blog/designing-futures/cover.jpg": [1536, 1536],
};

/* Spread onto an <img>: imageSize(src) gives {width, height}, or {} for an
   image we have no measurement for. */
export default function imageSize(src) {
  const size = SIZES[src];
  return size ? { width: size[0], height: size[1] } : {};
}

/* Smaller copies written by `npm run images` (scripts/image-variants.cjs).
   responsive(src, sizes) gives {srcSet, sizes} to spread onto an <img> when
   a small copy exists, so phones fetch the half-size file; {} otherwise. */

export function responsive(src, sizes) {
  const variant = VARIANTS[src];
  if (!variant) return {};
  return { srcSet: `${variant.sm} ${variant.smW}w, ${src} ${variant.w}w`, sizes };
}
